/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Missing_DocumentInputs */

const en_inbound_issue_missing_document = /** @type {(inputs: Inbound_Issue_Missing_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a document is missing`)
};

/**
* | output |
* | --- |
* | "a document is missing" |
*
* @param {Inbound_Issue_Missing_DocumentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_missing_document = /** @type {((inputs?: Inbound_Issue_Missing_DocumentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Missing_DocumentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_missing_document(inputs)
});